const DataApi = [
    {
        id:1,
        discount: "25%",
        name:"Rich Dad Poor Dad",
        category:"Motivational",
        Author: "Kiyosaki Robert",
        Language: "English",
        cash_on_delivery: true,
        price: 292,
        Real_Price:499,
        img: "/books/rich-dad-poor-dad.jpeg"
    },
    {
        id:2,
        discount:"10%",
        name:"core-python-programming",
        category:"coding",
        Author: "Dr. R.Nageshwara Rao",
        Language: "English",
        cash_on_delivery:false,
        price: 689,
        Real_Price:799,
        img: "/books/core-python-programming.jpeg"
    },
    {
        id:3,
        discount:"20%",
        name:"mastering javascript",
        Author: "Kiyosaki Robert",
        category:"coding",
        Language: "English",
        cash_on_delivery: true,
        price: 292,
        Real_Price:499,
        img: "/books/mastering-javascript.jpeg"
    },
    {
        id:4,
        discount:"10%",
        name:"Biography Of Ratan Tata",
        Author: "A.K. Gandhi",
        category:"history",
        Language: "English",
        cash_on_delivery: true,
        price:142,
        Real_Price:259,
        img: "/books/A Complete Biography Of Ratan Tata.jpeg"
    },
    {
        id:5,
        discount:"5%",
        name:"Chhava",
        Author: "Shivaji Sawant",
        category:"history",
        Language: "Marathi",
        cash_on_delivery: true,
        price:420,
        Real_Price:459,
        img: "/books/chhava.webp"
    },
    {
        id:6,
        discount:"10%",
        name:"Biography Of Ratan Tata",
        Author: "A.K. Gandhi",
        category:"history",
        Language: "English",
        cash_on_delivery: true,
        price:142,
        Real_Price:259,
        img: "/books/A Complete Biography Of Ratan Tata.jpeg"
    },
    {
        id:5,
        discount:"13%",
        name:"Srimad Bhagvad Gita",
        Author: " A.C Bhaktivedanta Swami Prabhupada ",
        category:"history",
        Language: "Hindi",
        cash_on_delivery: true,
        price:320,
        Real_Price:409,
        img: "/books/bhavgvat gita.jpg"
    }
   
]

export default DataApi;